import { AuthenticationType } from '../enums/authentication-type.enum';
import { WebhookEventType } from '../enums/webhook-event-type.enum';
import { HttpMethod } from '../enums/http-method.enum';
import { WebhookStatus } from '../enums/webhook-status.enum';

export class Webhook {
  webhookId: string;
  name: string;
  status: WebhookStatus;
  brandId: string;
  method: HttpMethod;
  url: string;
  authenticationType: AuthenticationType;
  maxRetryAttempts: number;
  eventResource: string;
  eventTypes: WebhookEventType[];
  createdTs: Date;
  modifiedTs: Date;
}
